//
//
//
//

export default {
    created: function created() {
        if (this.$auth.isAuthenticated()) {
            this.$auth.destroyToken();
        }

        this.$parent.$emit('login-logout-event');
        this.$router.push({ name: 'lang', params: { lang: this.lang } });
    },

    computed: {
        lang: function lang() {
            return this.$root._route.params.lang;
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/logout.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/logout.vue
// module chunks = 49